module.exports = __webpack_public_path__ + "93916724c5a975f97032da08b36a624a.gif";